import accounting from "accounting"

export const formatCount = (am) => accounting.formatNumber(am, 0, ",", ".")
export const formatAmount = (am) => `$${accounting.formatNumber(am, 2, ",", ".")}`
